// Container for FOBSeasonalityChart that fetches seasonality data
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertCircle } from 'lucide-react';
import Colors from '../../../constants/Colors';
import PageSkeleton from '../../../components/PageSkeleton';
import FOBSeasonalityChart from './FOBSeasonalityChart';
import { useFobSeasonalityData } from '../../../utils/api-hooks/analytics';

/**
 * Container component that fetches seasonality data
 * for the FOBSeasonalityChart
 */
const FOBSeasonalityChartContainer = ({ apiParams }) => {
  const { t } = useTranslation();
  const { email, commodity } = apiParams || {};

  // Fetch seasonality data
  const { data, origins, yearsAnalyzed, isLoading, isError, error } = useFobSeasonalityData(email, commodity);

  // Loading state
  if (isLoading) {
    return <PageSkeleton shape="chart" />;
  }

  // Error state
  if (isError) {
    return (
      <div className="h-full w-full flex flex-col items-center justify-center gap-3 px-4">
        <AlertCircle
          size={32}
          style={{ color: Colors.error || '#ef4444' }}
        />
        <p className="text-gray-400 text-sm text-center">
          {error?.message || t('charts.errorLoading')}
        </p>
      </div>
    );
  }

  return (
    <FOBSeasonalityChart
      data={data || []}
      origins={origins || []}
      years={yearsAnalyzed || []}
    />
  );
};

export default FOBSeasonalityChartContainer;
